var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1.08398C3.75736 1.08398 2.75 2.09134 2.75 3.33398V16.6673C2.75 17.91 3.75736 18.9173 5 18.9173H15C16.2426 18.9173 17.25 17.91 17.25 16.6673V6.66732C17.25 6.66425 17.25 6.66118 17.2499 6.65811C17.2475 6.50684 17.1865 6.36226 17.0794 6.25506C17.0793 6.25498 17.0794 6.25513 17.0794 6.25506L12.0791 1.25484C12.0779 1.25359 12.0766 1.25234 12.0754 1.2511C11.9701 1.14774 11.8258 1.08398 11.6667 1.08398H5ZM11.0833 2.25065H5C4.40169 2.25065 3.91667 2.73568 3.91667 3.33398V16.6673C3.91667 17.2656 4.40169 17.7507 5 17.7507H15C15.5983 17.7507 16.0833 17.2656 16.0833 16.6673V7.25065H11.6667C11.3445 7.25065 11.0833 6.98948 11.0833 6.66732V2.25065ZM15.2584 6.08398L12.25 3.07561V6.08398H15.2584Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08333 10.834C6.08333 10.5118 6.3445 10.2507 6.66667 10.2507H13.3333C13.6555 10.2507 13.9167 10.5118 13.9167 10.834C13.9167 11.1562 13.6555 11.4173 13.3333 11.4173H6.66667C6.3445 11.4173 6.08333 11.1562 6.08333 10.834Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08333 14.1673C6.08333 13.8452 6.3445 13.584 6.66667 13.584H13.3333C13.6555 13.584 13.9167 13.8452 13.9167 14.1673C13.9167 14.4895 13.6555 14.7507 13.3333 14.7507H6.66667C6.3445 14.7507 6.08333 14.4895 6.08333 14.1673Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08333 7.50065C6.08333 7.17848 6.3445 6.91732 6.66667 6.91732H8.33333C8.6555 6.91732 8.91667 7.17848 8.91667 7.50065C8.91667 7.82282 8.6555 8.08398 8.33333 8.08398H6.66667C6.3445 8.08398 6.08333 7.82282 6.08333 7.50065Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.b014cf3d1ab7468fd067778a7673c8b5.svg";
export { ForwardRef as ReactComponent };